import { AnalogTemperatureSensor, BoilerAdapterProcessor, BoilerAdapterType, HeatingCircuit, HeatingMode, IOExtension, NTCTemperatureCurve, } from 'z3k-config';
import { analog_input_id, ats_air_id, ats_water_id, boiler_adapter_id, boiler_with_reserve_ti_id, boiler_with_reserve_timetable_id, command_off_id, command_on_id, consumer_ti_id, consumer_timetable_id, dhw_ti_id, dhw_timetable_id, hc_boiler_id, hc_dhw_id, hc_id, hc_reserve_id, hm_comfort_id, hm_economy_id, hm_off_id, hm_reserve_id, hm_schedule_id, hm_summer_id, io_extensions_id, notification_connection_lost_id, notification_find_power_id, notification_lost_power_id, notification_low_balance_id, notifications_boiler_error_id, ntc_curve_id, relay_id, reserve_boiler_ti_id, reserve_boiler_timetable_id, user_id, } from './ids';
import { c2k } from 'utils';
export const ai_battery = {
    id: analog_input_id,
    physical_input_num: 1,
    name: 'Напряжение питания',
    upper_threshold: 0.28,
    lower_threshold: 0.09,
    active_level_timeout: 1,
    inactive_level_timeout: 1,
    setting_register: 1, // func
    notification_list: [notification_lost_power_id],
    sensor_type: 0,
    recovery_list: [notification_find_power_id],
    upper_notification_list: [],
    impulse_frequency: 1,
    calibration: null,
    position: 0,
    units: 0,
};
export const notification_low_balance = {
    id: notification_low_balance_id,
    name: 'Баланс ниже порога',
    setting_register: 1, //func
    sms_text: 'Баланс ниже порога! $value$',
    voice_text: '',
    recipient_list: [user_id],
};
export const notification_lost_power = {
    id: notification_lost_power_id,
    name: 'Пропадание основного питания',
    setting_register: 1, //func
    sms_text: 'Пропадание основного питания!',
    voice_text: '',
    recipient_list: [user_id],
};
export const notification_find_power = {
    id: notification_find_power_id,
    name: 'Появление основного питания',
    setting_register: 1, //func
    sms_text: 'Появление основного питания!',
    voice_text: '',
    recipient_list: [user_id],
};
export const notification_conn_lost = {
    id: notification_connection_lost_id,
    name: 'Потеря связи с внешним устройством',
    setting_register: 1, //func
    sms_text: '$name$ -- нет соединения!',
    voice_text: '',
    recipient_list: [user_id],
};
export const notification_boiler_error = {
    id: notifications_boiler_error_id,
    name: 'Ошибка котла',
    setting_register: 1, //func
    sms_text: 'Внимание! Ошибка котла №$value$',
    voice_text: '',
    recipient_list: [user_id],
};
export const user20533 = {
    id: user_id,
    name: 'Пользователь',
    phone: '',
    key_and_radiotag_list: [],
    role_list: [],
    password: '',
    setting_register: 0, //func
};
export const boilerAdapter20600 = {
    id: boiler_adapter_id,
    isManual: false,
    serial: {
        builtIn: true,
        value: '0000',
    },
    name: 'Адаптер цифровой шины',
    type: 0,
    max_modulation_level: 100,
    logged_parameter_register: 639,
    boiler_model: 'baxi',
    rol_connection_lost: [notification_connection_lost_id],
    rol_boiler_failure: [notifications_boiler_error_id],
    slot: 0,
    position: 0,
    rol_connection_found: [],
    rol_boiler_restore: [],
    hardware: 'Unknown',
    processor: BoilerAdapterProcessor.UNKNOWN,
    adapter_type: BoilerAdapterType.UNKNOWN,
};
export const relay20488 = {
    id: relay_id,
    name: 'Реле',
    physical_output: 0,
    setting_register: 9, //func
};
export const command_relay_on = {
    id: command_on_id,
    name: 'Включить реле "Реле"',
    objectid: relay_id,
    cmd: '1',
};
export const command_relay_off = {
    id: command_off_id,
    name: 'Выключить реле "Реле"',
    objectid: relay_id,
    cmd: '0',
};
export const command_relay_leak_on = {
    id: command_on_id,
    name: 'Включить реле "Реле Протечки"',
    objectid: relay_id,
    cmd: '1',
};
export const command_relay_leak_off = {
    id: command_off_id,
    name: 'Выключить реле "Реле Протечки"',
    objectid: relay_id,
    cmd: '0',
};
export const wts_water = {
    serial: '1',
    name: 't° ТН',
    upper_threshold: 0,
    lower_threshold: 0,
    hysteresis: 0,
    no_connection_timeout: 5,
    rol_connection_lost: [],
    rol_temperature_upper_threshold: [],
    rol_temperature_lower_threshold: [],
    io_extension_id: null,
    recovery_list: [],
    setting_register: 8192,
    position: 1,
    calibration_shift: 0,
};
export const wts_air = {
    serial: '2',
    name: 't° воздуха',
    upper_threshold: 0,
    lower_threshold: 0,
    hysteresis: 0,
    no_connection_timeout: 5,
    rol_connection_lost: [],
    rol_temperature_upper_threshold: [],
    rol_temperature_lower_threshold: [],
    io_extension_id: null,
    recovery_list: [],
    setting_register: 0,
    position: 2,
    calibration_shift: 0,
};
export const wts_outside = {
    serial: 'FF00FF00FF00FF',
    name: 'Погода из интернета',
    upper_threshold: null,
    lower_threshold: null,
    hysteresis: 0,
    no_connection_timeout: 0,
    rol_connection_lost: [],
    rol_temperature_upper_threshold: [],
    rol_temperature_lower_threshold: [],
    io_extension_id: null,
    recovery_list: [],
    setting_register: 0,
    position: 0,
    calibration_shift: 0,
};
export const pza8194 = {
    name: 'Кривая ПЗА',
    x: [2930, 2828, 2732, 2637, 2547, 2432, 2335],
    y: [2930, 3088, 3205, 3306, 3386, 3461, 3509],
};
export const hc_boiler = {
    id: hc_boiler_id,
    name: 'Котел',
    type: HeatingCircuit.Type.BOILER,
    water_min_temperature: 30,
    water_max_temperature: 85,
    air_temp_sensor: null,
    air_temp_sensor_reserve: null,
    dhw_temp_sensor: null,
    dhw_temp_sensor_reserve: null,
    water_temp_sensor: null,
    water_temp_sensor_reserve: null,
    hysteresis: 10,
    control_devices: [],
    setting_register: 256, //func
    turn_off_delay: 0,
    external_thermostat: null,
    heat_request: 0,
    pza: 0,
    heat_source: null,
    antileg_mode_options: {
        m: 0 & ((1 << 8) - 1),
        h: (0 >> 8) & ((1 << 8) - 1),
        days: (0 >> 16) & ((1 << 8) - 1),
    },
    summer_threshold: 0,
    winter_summer_switch: false,
    position: 0,
    locker_id: null,
    delta_temp: 0,
};
export const hc_consumer = {
    id: hc_id,
    name: 'Отопление',
    type: HeatingCircuit.Type.HEATING,
    water_min_temperature: 30,
    water_max_temperature: 85,
    air_temp_sensor: null,
    air_temp_sensor_reserve: null,
    dhw_temp_sensor: null,
    dhw_temp_sensor_reserve: null,
    water_temp_sensor: null,
    water_temp_sensor_reserve: null,
    hysteresis: 1,
    control_devices: [],
    setting_register: 514, //func
    turn_off_delay: 0,
    external_thermostat: null,
    heat_request: HeatingCircuit.HEAT_REQUEST__CONSTANT,
    pza: 0,
    heat_source: null,
    antileg_mode_options: {
        m: 0 & ((1 << 8) - 1),
        h: (0 >> 8) & ((1 << 8) - 1),
        days: (0 >> 16) & ((1 << 8) - 1),
    },
    summer_threshold: 0,
    winter_summer_switch: false,
    position: 0,
    locker_id: null,
    delta_temp: 0,
};
export const hc_dhw = {
    id: hc_dhw_id,
    name: 'ГВС',
    type: HeatingCircuit.Type.DHW,
    water_min_temperature: null,
    water_max_temperature: null,
    air_temp_sensor: null,
    air_temp_sensor_reserve: null,
    dhw_temp_sensor: boiler_adapter_id,
    dhw_temp_sensor_reserve: null,
    water_temp_sensor: null,
    water_temp_sensor_reserve: null,
    hysteresis: 5,
    control_devices: [boiler_adapter_id],
    setting_register: 32,
    turn_off_delay: 0,
    external_thermostat: null,
    heat_request: 0,
    pza: 0,
    heat_source: null,
    antileg_mode_options: {
        m: 0 & ((1 << 8) - 1),
        h: (0 >> 8) & ((1 << 8) - 1),
        days: (0 >> 16) & ((1 << 8) - 1),
    },
    summer_threshold: 0,
    winter_summer_switch: false,
    position: 0,
    locker_id: null,
    delta_temp: 0,
};
export const hc_reserve = (sensorId) => {
    return {
        id: hc_reserve_id,
        name: 'Резерв',
        type: HeatingCircuit.Type.BOILER,
        water_min_temperature: 5,
        water_max_temperature: 85,
        air_temp_sensor: null,
        air_temp_sensor_reserve: null,
        dhw_temp_sensor: null,
        dhw_temp_sensor_reserve: null,
        water_temp_sensor: sensorId,
        water_temp_sensor_reserve: null,
        hysteresis: 1,
        control_devices: [relay_id],
        setting_register: 256,
        turn_off_delay: 0,
        external_thermostat: null,
        heat_request: 0,
        pza: 0,
        heat_source: null,
        antileg_mode_options: {
            m: 0 & ((1 << 8) - 1),
            h: (0 >> 8) & ((1 << 8) - 1),
            days: (0 >> 16) & ((1 << 8) - 1),
        },
        summer_threshold: 0,
        winter_summer_switch: false,
        position: 0,
        locker_id: null,
        delta_temp: 0,
    };
};
export const hm_comfort = {
    id: hm_comfort_id,
    name: 'Комфорт',
    heating_zones: [
        {
            heating_circuit: hc_id,
            temperature_setting: c2k(24),
            adjusting_sensor: null,
            pza: null,
        },
    ],
    setting_register: 5, //func
    start_reserve_delay: 10,
    water_sensor: null,
    hysteresis: 1,
    position: 0,
    force_boiler_mode: false,
    max_modulation_level: 0,
};
export const hm_eco = {
    id: hm_economy_id,
    name: 'Эконом',
    heating_zones: [
        {
            heating_circuit: hc_id,
            temperature_setting: c2k(15),
            adjusting_sensor: null,
            pza: null,
        },
    ],
    setting_register: 11, //func
    start_reserve_delay: 10,
    water_sensor: null,
    hysteresis: 1,
    position: 0,
    force_boiler_mode: false,
    max_modulation_level: 0,
};
export const hm_schedule = {
    id: hm_schedule_id,
    name: 'Расписание',
    heating_zones: [
        {
            heating_circuit: hc_id,
            temperature_setting: consumer_timetable_id,
            adjusting_sensor: null,
            pza: null,
        },
    ],
    setting_register: 31, //func
    start_reserve_delay: 10,
    water_sensor: null,
    hysteresis: 1,
    position: 0,
    force_boiler_mode: false,
    max_modulation_level: 0,
};
export const hm_off = {
    id: hm_off_id,
    name: 'Выключен',
    heating_zones: [
        {
            heating_circuit: hc_id,
            temperature_setting: HeatingMode.OFF_MODE,
            adjusting_sensor: null,
            pza: null,
        },
    ],
    setting_register: 29, //func
    start_reserve_delay: 10,
    water_sensor: null,
    hysteresis: 1,
    position: 0,
    force_boiler_mode: false,
    max_modulation_level: 0,
};
export const hm_reserve = (sensorId) => {
    return {
        id: hm_reserve_id,
        name: 'Резерв',
        heating_zones: [
            {
                heating_circuit: hc_boiler_id,
                temperature_setting: HeatingMode.REQUEST_MODE,
                adjusting_sensor: null,
                pza: null,
            },
            {
                heating_circuit: hc_reserve_id,
                temperature_setting: HeatingMode.RESERVE_MODE,
                adjusting_sensor: null,
                pza: null,
            },
        ],
        setting_register: 32,
        start_reserve_delay: 10,
        water_sensor: sensorId,
        hysteresis: 5,
        position: 0,
        force_boiler_mode: false,
        max_modulation_level: 0,
    };
};
export const hm_summer = {
    id: hm_summer_id,
    name: 'Лето',
    heating_zones: [
        {
            heating_circuit: hc_id,
            temperature_setting: HeatingMode.OFF_MODE,
            adjusting_sensor: null,
            pza: null,
        },
        {
            heating_circuit: hc_dhw_id,
            temperature_setting: c2k(50),
            adjusting_sensor: null,
            pza: null,
        },
    ],
    setting_register: 0,
    start_reserve_delay: 10,
    water_sensor: null,
    hysteresis: 1,
    position: 0,
    force_boiler_mode: false,
    max_modulation_level: 0,
};
export const timetable_consumer = {
    id: consumer_timetable_id,
    time_intervals: [consumer_ti_id],
    outside_default: c2k(18),
    setting_register: 0,
};
export const consumer_timeinterval = {
    id: consumer_ti_id,
    sm: 0,
    sh: 7,
    em: 0,
    eh: 23,
    temperature: c2k(22),
    action_register: 127,
};
export const timetable_dhw = {
    id: dhw_timetable_id,
    time_intervals: [dhw_ti_id],
    outside_default: c2k(20),
    setting_register: 0,
};
export const dhw_timeinterval = {
    id: dhw_ti_id,
    sm: 0,
    sh: 6,
    em: 0,
    eh: 23,
    temperature: c2k(45),
    action_register: 127,
};
export const timetable_boiler_with_reserve = {
    id: boiler_with_reserve_timetable_id,
    time_intervals: [boiler_with_reserve_ti_id],
    outside_default: HeatingMode.RESERVE_MODE,
    setting_register: 0,
};
export const boiler_with_reserve_timeinterval = {
    id: boiler_with_reserve_ti_id,
    sm: 0,
    sh: 7,
    em: 0,
    eh: 23,
    temperature: HeatingMode.REQUEST_MODE,
    action_register: 127,
};
export const reserve_boiler_timetable = {
    id: reserve_boiler_timetable_id,
    time_intervals: [reserve_boiler_ti_id],
    outside_default: HeatingMode.REQUEST_MODE,
    setting_register: 0,
};
export const reserve_boiler_timeinterval = {
    id: reserve_boiler_ti_id,
    sm: 0,
    sh: 7,
    em: 0,
    eh: 23,
    temperature: HeatingMode.RESERVE_MODE,
    action_register: 127,
};
//For esp devices
export const io_extension = {
    id: io_extensions_id,
    serial: '0000',
    name: 'Блок расширения',
    rol_connection_lost: [],
    device_version: '707 1',
    bus_address: 0,
    type: IOExtension.Type.BUILTIN_BOARD,
    related_list: [],
    setting_register: 0,
};
export const analogInputESP = {
    ...ai_battery,
    physical_input_num: 328819,
    name: 'Напряжение питания',
};
export const relayESP = {
    ...relay20488,
    physical_output: 328816,
};
export const nts_curve = {
    id: ntc_curve_id,
    x: NTCTemperatureCurve.ntcDefaultX[AnalogTemperatureSensor.Type.NTC10],
    y: NTCTemperatureCurve.ntcDefaultY,
};
export const ats_water = {
    id: ats_water_id,
    physical_input_num: 328822, //вход NTC 2
    name: wts_water.name,
    type: AnalogTemperatureSensor.Type.NTC10,
    lower_threshold: null,
    upper_threshold: null,
    hysteresis: 0,
    no_connection_timeout: 5,
    rol_connection_lost: [notification_connection_lost_id],
    rol_temperature_upper_threshold: [],
    rol_temperature_lower_threshold: [],
    ntc: ntc_curve_id,
    pull_up: 0,
    calibration_shift: 0,
    recovery_list: [],
    setting_register: 0,
    position: 0,
};
export const ats_air = {
    id: ats_air_id,
    physical_input_num: 328821, //вход NTC 1
    name: wts_air.name,
    type: AnalogTemperatureSensor.Type.NTC10,
    upper_threshold: null,
    lower_threshold: null,
    hysteresis: 0,
    no_connection_timeout: 5,
    rol_connection_lost: [notification_connection_lost_id],
    rol_temperature_upper_threshold: [],
    rol_temperature_lower_threshold: [],
    ntc: ntc_curve_id,
    pull_up: 0,
    calibration_shift: 0,
    recovery_list: [],
    setting_register: 0,
    position: 0,
};
